// Fingerprint switches live on the backend (GET /api/fingerprint-features), so one
// change there turns a feature off here, in inferencing and in the backend alike.
// index.js loads them once before the app renders; until then, or when the read
// fails, every fingerprint screen and button stays hidden.
const FEATURES_TIMEOUT_MS = 5000;

let fingerprintFeatures = {};

export const setFingerprintFeatures = (features) => {
  fingerprintFeatures = features && typeof features === "object" ? features : {};
};

export const loadFingerprintFeatures = async ({
  baseUrl = process.env.REACT_APP_BASE_URL,
  fetchImpl = typeof fetch === "function" ? fetch : undefined,
} = {}) => {
  const controller = typeof AbortController === "function" ? new AbortController() : null;
  const timer = controller && setTimeout(() => controller.abort(), FEATURES_TIMEOUT_MS);
  try {
    const response = await fetchImpl(`${baseUrl}/api/fingerprint-features`, {
      signal: controller?.signal,
    });
    setFingerprintFeatures(response.ok ? await response.json() : {});
  } catch (_error) {
    setFingerprintFeatures({});
  } finally {
    if (timer) clearTimeout(timer);
  }
};

// Fingerprinting as a whole: Fingerprint Master, decision traces, FP origins.
export const isPlayoutFingerprintEnabled = () => fingerprintFeatures.enabled === true;

// One feature: "ads", "promos", "anchors", "reporters" or "program_name".
export const isFingerprintFeatureEnabled = (feature) => fingerprintFeatures[feature] === true;

// Enrolment kinds and voice roles, by the feature that owns them.
const KIND_FEATURES = { commercial: "ads", promo: "promos", anchor: "anchors", reporter: "reporters" };

export const isFingerprintKindEnabled = (kind) =>
  Boolean(KIND_FEATURES[kind]) && isFingerprintFeatureEnabled(KIND_FEATURES[kind]);

// The Mapping health button on Headline Master. Off unless set to "true".
export const isMappingHealthEnabled = () =>
  process.env.REACT_APP_MAP_HEALTH === "true";
